export const OPEN_VEHICLE_EDIT_DIALOG = "OPEN_VEHICLE_EDIT_DIALOG";
export const CLOSE_VEHICLE_EDIT_DIALOG = "CLOSE_VEHICLE_EDIT_DIALOG";
